import { h, Component } from 'preact';
import util from 'preact-util';
import { observer } from 'mobx-preact';
import { Text, Localizer, withText } from 'preact-i18n';
import Markdown from 'preact-markdown';

import localUtil from '../../lib/util';
import fields from '../../lib/fields';

import FormFieldsCompact from '../../components/form/fieldsCompact';
import Input from '../../components/form/input';

@withText(props => ({
    orderNumber: <Text id='input.orderNumber-help'>orderNumber</Text>,
    name: <Text id='input.name-help'>name</Text>,
    description: <Text id='input.description-help'>description</Text>,
    installation: <Text id='input.installation-help'>installation</Text>,
    url: <Text id='input.url-help'>url</Text>,
}))
@observer
class NewLoan extends Component {
  	constructor(props) {
        super(props);
        this.state = {
            sections: fields.get('loan'),
        };
    }

    createLoan = async () => {
        const { callback = () => {} } = this.props;
        const { loanStore } = this.props.stores;
        const { newLoan } = loanStore;
        const response = await loanStore.adminCreate(newLoan);
        if (response.status === 201) {
            callback();
        }
    }

    componentDidMount() {
        const { idx, id, isNew } = this.props;
        const { loanStore } = this.props.stores;
        if (!isNew) {
            // loanStore.adminSetFromIdx(idx);
            loanStore.adminSetFromId(id);
        }
    }

    render() {
        const { week, isNew, drawerLevel } = this.props;
        const { sections } = this.state;
        const { userStore, loanStore } = this.props.stores;
        const { user, isAdmin } = userStore;
        const { newLoan } = loanStore;
        const darkmode= util.getNestedValue(user, 'settings.darkmode');

        return (<>
            <div class='w-100 d-flex justify-content-center'>
                <div class='w-100' style='max-width: 960px; padding-top: 20px; padding-bottom: 100px;'>

                    <div class='font-weight-lighter px-3 box-header mt-0'>
                        {isNew ? <Text id='loan.new'>New loan</Text> : <Text id='loan.edit'>Edit loan</Text>}
                    </div>

                    <div class='bg-light d-flex flex-column justify-content-start h-100 pt-3'>
                        <FormFieldsCompact stores={this.props.stores} sections={sections} holdingStore={loanStore} objectName={isNew ? 'newLoan' : 'loan'} isNew={isNew} drawerLevel={drawerLevel} isAdmin={true} />
                    </div>

                    {isNew && <div class='w-100 d-flex flex-column justify-content-start mt-3 px-4 py-3 bg-light fixed-bottom' style={`bottom: 0; left: 0;`}>
                        <button type='button' class='btn btn-primary rounded-pill' onClick={this.createLoan}>
                            {isNew ? <Text id='loan.create'>Create loan</Text> : <Text id='loan.save'>Save loan</Text>}
                        </button>
                    </div>}
                </div>
            </div>
        </>);
    }
}

export default NewLoan;
